import { TamaguiProvider as TamaguiProviderOG } from 'tamagui';
import { config } from './tamagui.config';
import type { ReactNode } from 'react';

interface TamaguiProviderProps {
  children: ReactNode;
}

export function TamaguiProvider({ children }: TamaguiProviderProps) {
  return (
    <TamaguiProviderOG config={config} defaultTheme="light">
      {children}
    </TamaguiProviderOG>
  );
}
